var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    { attrs: { shrink: "" } },
    [
      _c(
        "v-card",
        { staticClass: "shadow-none", attrs: { outlined: "" } },
        [
          _c(
            "v-card-text",
            { staticClass: "pa-0" },
            [
              _c(
                "v-row",
                { staticClass: "my-1", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-text-field", {
                        ref: "documentNbr",
                        staticClass: "py-1 pl-2 custom-text-field",
                        attrs: {
                          value: _vm.filterSelection.documentNbr
                            ? _vm.filterSelection.documentNbr.text
                            : "",
                          label: _vm.$t("label.documentNbr"),
                          "menu-props": _vm.menuProps,
                          "hide-details": "",
                          clearable: "",
                          dense: "",
                        },
                        on: {
                          change: (v) =>
                            _vm.onFieldChange(
                              v,
                              "documentNbr",
                              "text",
                              "value"
                            ),
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.setFilter.apply(null, arguments)
                          },
                          "click:clear": function ($event) {
                            return _vm.onClear("documentNbr")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-text-field", {
                        ref: "clientName",
                        staticClass: "pa-1 custom-text-field",
                        attrs: {
                          value: _vm.filterSelection.clientName
                            ? _vm.filterSelection.clientName.text
                            : "",
                          label: _vm.$t("label.customer"),
                          "menu-props": _vm.menuProps,
                          "hide-details": "",
                          clearable: "",
                          dense: "",
                        },
                        on: {
                          change: (v) =>
                            _vm.onFieldChange(v, "clientName", "text", "value"),
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.setFilter.apply(null, arguments)
                          },
                          "click:clear": function ($event) {
                            return _vm.onClear("clientName")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-text-field", {
                        ref: "consigneeName",
                        staticClass: "pa-1 custom-text-field",
                        attrs: {
                          value: _vm.filterSelection.consigneeName
                            ? _vm.filterSelection.consigneeName.text
                            : "",
                          label: _vm.$t("label.consignee"),
                          "menu-props": _vm.menuProps,
                          "hide-details": "",
                          clearable: "",
                          dense: "",
                        },
                        on: {
                          change: (v) =>
                            _vm.onFieldChange(
                              v,
                              "consigneeName",
                              "text",
                              "value"
                            ),
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.setFilter.apply(null, arguments)
                          },
                          "click:clear": function ($event) {
                            return _vm.onClear("consigneeName")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-text-field", {
                        ref: "shipperName",
                        staticClass: "pa-1 custom-text-field",
                        attrs: {
                          value: _vm.filterSelection.shipperName
                            ? _vm.filterSelection.shipperName.text
                            : "",
                          label: _vm.$t("label.shipperName"),
                          "menu-props": _vm.menuProps,
                          "hide-details": "",
                          clearable: "",
                          dense: "",
                        },
                        on: {
                          change: (v) =>
                            _vm.onFieldChange(
                              v,
                              "shipperName",
                              "text",
                              "value"
                            ),
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.setFilter.apply(null, arguments)
                          },
                          "click:clear": function ($event) {
                            return _vm.onClear("shipperName")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-text-field", {
                        ref: "shipperInvoiceReference",
                        staticClass: "pa-1 custom-text-field",
                        attrs: {
                          value: _vm.filterSelection.shipperInvoiceReference
                            ? _vm.filterSelection.shipperInvoiceReference.text
                            : "",
                          label: _vm.$t("label.shipperInvoiceReference"),
                          "menu-props": _vm.menuProps,
                          "hide-details": "",
                          clearable: "",
                          dense: "",
                        },
                        on: {
                          change: (v) =>
                            _vm.onFieldChange(
                              v,
                              "shipperInvoiceReference",
                              "text",
                              "value"
                            ),
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.setFilter.apply(null, arguments)
                          },
                          "click:clear": function ($event) {
                            return _vm.onClear("shipperInvoiceReference")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c("v-text-field", {
                        ref: "userLabel",
                        staticClass: "py-1 pr-2 custom-text-field",
                        attrs: {
                          value: _vm.filterSelection.userLabel
                            ? _vm.filterSelection.userLabel.text
                            : "",
                          label: _vm.$t("label.userLabel"),
                          "menu-props": _vm.menuProps,
                          "hide-details": "",
                          clearable: "",
                          dense: "",
                        },
                        on: {
                          change: (v) =>
                            _vm.onFieldChange(v, "userLabel", "text", "value"),
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.setFilter.apply(null, arguments)
                          },
                          "click:clear": function ($event) {
                            return _vm.onClear("userLabel")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }